<div fxLayout="column" style="width: 100%;">
    @if (hasFilter) {
    <div class="pad-bottom-0">
        <form name="tableFilterPanelForm">
            @if (hasFilter) {
            <metadata-panel ngModelGroup="gridFilter" fxFlex="auto" [metadata]="gridMetadata.FilterMetadata"
                [model]="filterModel" [datacontroller]="filterDataController"
                (modifierCallback)="filterCallback($event)">
            </metadata-panel>
            }
        </form>
    </div>
    }

    @if (!loading) {
    <info-grid [displayHeader]="displayHeader" [useRepository]="UseRepository" [noFilter]="viewMetadata.HideFilter"
        [viewMetadata]="viewMetadata" [viewOnly]="viewMetadata.ViewOnly" [model]="model"
        [datacontroller]="datacontroller" [disableViewAction]="disableViewAction"
        (repositoryFunction)="doRepositoryFunction($event)" (onSelected)="onSelected($event)"
        [disableGridAdd]="disableGridAdd" [multipleEdit]="multipleEdit" style="height: 100%;" [parentView]="parentView"
        [isStepperGrid]="isStepperGrid">
    </info-grid>
    }
</div>